<template>
  <profile-main>
    <profile-header activeMenu="autoPayment" slot="profileNavigation" />
    <loading-container :loading="apiKeyLoading">
      <div class="card">
        <h5 class="card-title">Auto Payment setting</h5>
        <div class="d-flex no-block align-items-center m-t-20 m-b-20">
          <form @submit.prevent="() => {}" class="w-100">
            <div class="form-group">
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="custom-control custom-radio" v-if="isOffPaymentSelected()">
                      <input type="radio"
                        id="off"
                        name="paymentType"
                        value="off"
                        :checked="currentPayment === 'off'"
                        class="custom-control-input"
                        @change="changeAutoPayment('off')">
                      <label class="custom-control-label" for="off">Off</label>
                  </div>
                  <alert-box v-if="originPayment === 'credit'" type="success" class="btn-xs m-b-0 d-inline-block">
                    You have enabled autopayment with credit
                  </alert-box>
                  <div class="custom-control custom-radio" v-if="isOffPaymentSelected()">
                    <input type="radio"
                      id="credit1"
                      name="paymentType"
                      value="credit"
                      :checked="currentPayment === 'credit'"
                      class="custom-control-input"
                      @change="changeAutoPayment('credit')">
                    <label class="custom-control-label" for="credit1">Credit</label>
                  </div>
                  <alert-box v-if="originPayment === 'payoneer'" type="success" class="btn-xs m-b-0 d-inline-block">
                    You have enabled autopayment with connected payoneer account: {{userData.payoneer.accountId}} ({{parseFloat(userData.payoneer.balance) | priceDisplay}})
                  </alert-box>
                  <div class="custom-control custom-radio" v-if="isOffPaymentSelected()" v-show="payoneerEnabled">
                    <input type="radio"
                      id="payoneer"
                      name="paymentType"
                      value="payoneer"
                      :checked="currentPayment === 'payoneer'"
                      class="custom-control-input"
                      @change="changeAutoPayment('payoneer')">
                    <label class="custom-control-label" for="payoneer">Payoneer</label>
                  </div>
                </div>
              </div>
              <div v-if="displaySelectAutoPaymentHours">Verified orders are paid automatically every <b><i>{{ autoPaymentHours || 2 }}</i></b> hours.</div>
              <d-select-input
                v-if="displaySelectAutoPaymentHours"
                :options="autoPaymentHoursOptions"
                @input="(v) => changeAutoPaymentHours(v)"
                :value="autoPaymentHours || 2"
              />
            </div>
            <div class="form-group d-inline-block">
              <form-button
                v-if="isOffPaymentSelected()"
                class="btn-inline"
                type="primary"
                :disabled="currentPayment === 'off' ? true : false"
                :click="() => doSubmitAutoPayment()"
                :loading="autoPaymentLoading"
                input-type="button"
                text="Enable autopayment"
              />
              <form-button
                class="btn-inline"
                type="warning"
                v-else
                :click="() => turnOffAutoPayment()"
                :loading="autoPaymentLoading"
                input-type="button"
                text="Turn off autopayment"
              />
            </div>
          </form>
        </div>
      </div>
    </loading-container>
  </profile-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import InputText from '@/components/Form/InputText';
import RadioButton from '@/components/Form/RadioButton';
import FormButton from '@/components/Form/FormButton';
import LinkButton from '@/components/Misc/LinkButton';
import LoadingContainer from '@/components/Misc/LoadingContainer';
import ReferralStatus from '@/components/Common/ReferralStatus'
import ProfileHeader from './components/Header';
import ProfileMain from './components/Main';
import AlertBox from '@/components/Misc/AlertBox';
import DSelectInput from "@/components/input/DSelectInput";

export default {
  name: 'AutoPayment',
  components: {
    InputText,
    RadioButton,
    FormButton,
    LinkButton,
    ReferralStatus,
    LoadingContainer,
    ProfileHeader,
    ProfileMain,
    AlertBox,
    DSelectInput,
  },
  data() {
    return {
      autoPaymentHoursOptions: [
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 6, text: 6 },
      ],
    };
  },
  beforeMount() {
    this.getUserInfo();
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      userData: 'auth/userData',
      form: 'auth/form',
      apiKeyLoading: 'apiKey/loading',
      autoPaymentLoading: 'auth/autoPaymentLoading',
      currentPayment: 'auth/currentPayment',
      autoPaymentHours: 'auth/autoPaymentHours',
      originPayment: 'auth/originPayment',
    }),

    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
    payoneerEnabled() {
      return process.env.VUE_APP_PAYONEER === 'true';
    },
    displaySelectAutoPaymentHours() {
      return this.currentPayment !== "off";
    },
  },
  methods: {
    ...mapActions({
      setField: 'auth/setField',
      getUserInfo: 'auth/getUserInfo',
      changeAutoPayment: 'auth/changeAutoPayment',
      changeAutoPaymentHours: 'auth/changeAutoPaymentHours',
      submitChangeAutoPayment: 'auth/submitChangeAutoPayment',
      linkToPayoneerAuthen: 'auth/linkToPayoneerAuthen',
      turnOffAutoPayment: 'auth/turnOffAutoPayment',
    }),
    doSubmitAutoPayment() {
      if (this.currentPayment === 'payoneer') {
        this.linkToPayoneerAuthen();
      } else {
        this.submitChangeAutoPayment(false);
      }
    },
    isOffPaymentSelected() {
      return this.originPayment === 'off';
    }
  },
};
</script>
